import { CookieService } from '../../services/cookie-service';
import { MarketplaceRedirect } from '../../constants/cookies';

const reservedParams = ['marketplace', 'verified', 'sessionExpired', 'firsttime', 'redirect', 'shipStationIntelligence'];

const allowedMarketplaces = ['tiktok', 'tiktok_uk', 'walmart'];

const isValidMarketplace = (marketplace) => {
  return marketplace && allowedMarketplaces.includes(marketplace.toLowerCase());
};

const getForwardParams = (searchParams) => {
  const forwardParams = new URLSearchParams();
  searchParams.forEach((value, key) => {
    if (!reservedParams.includes(key)) {
      forwardParams.append(key, value);
    }
  });
  return forwardParams;
};

const buildMarketplaceAcceptUrl = (marketplace, forwardParams) => {
  const hostname = window.location.hostname.replace(/^ship/, 'ss');
  const baseUrl = `${window.location.protocol}//${hostname}/api/datadriven/oauth/accept/ordersource/${marketplace}`;

  const queryString = forwardParams?.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

const saveMarketplaceRedirect = (marketplace, searchParams) => {
  const forwardParams = getForwardParams(searchParams);
  const cookieValue = JSON.stringify({ marketplace, params: forwardParams.toString() });
  CookieService.setCookieValueWithExpirationInMinutes(MarketplaceRedirect, cookieValue, 15);
};

const consumeMarketplaceRedirect = () => {
  const raw = CookieService.getCookieValue(MarketplaceRedirect);
  if (!raw) {
    return null;
  }

  CookieService.removeCookie(MarketplaceRedirect);

  try {
    const { marketplace, params } = JSON.parse(raw);
    if (!isValidMarketplace(marketplace)) {
      return null;
    }
    const forwardParams = new URLSearchParams(params);
    return buildMarketplaceAcceptUrl(marketplace, forwardParams);
  } catch {
    return null;
  }
};

export { isValidMarketplace, buildMarketplaceAcceptUrl, saveMarketplaceRedirect, consumeMarketplaceRedirect };
